import { getDynmapBase } from './config';
import type { DynmapConfig, DynmapMapDef, DynmapWorld } from './types';

let cached: DynmapConfig | null = null;

export async function loadDynmapConfig(): Promise<DynmapConfig> {
  if (cached) return cached;
  // Prefer same-origin proxy (map2) so matrices match live Dynmap without CORS issues
  const bases = [getDynmapBase(), 'https://map.reborned.one'];
  for (const base of bases) {
    try {
      const res = await fetch(`${base.replace(/\/$/, '')}/up/configuration`, {
        mode: 'cors',
        credentials: 'omit',
      });
      if (!res.ok) continue;
      cached = (await res.json()) as DynmapConfig;
      if (cached?.worlds?.length) return cached;
    } catch {
      /* try next */
    }
  }
  cached = FALLBACK_CONFIG;
  return cached;
}

export function getWorld(cfg: DynmapConfig, name: string): DynmapWorld | undefined {
  return cfg.worlds?.find((w) => w.name === name);
}

export function getFlatMap(world: DynmapWorld): DynmapMapDef | undefined {
  return (
    world.maps.find((m) => m.name === 'flat' || m.prefix === 'flat') ||
    world.maps[0]
  );
}

/** Minimal fallback if configuration fetch fails (matches live map.reborned.one flat maps). */
const FALLBACK_CONFIG: DynmapConfig = {
  worlds: [
    {
      name: 'world',
      title: 'world',
      center: { x: 0, y: 90, z: 0 },
      maps: [
        {
          name: 'flat',
          title: 'Flat',
          prefix: 'flat',
          type: 'HDMapType',
          scale: 4,
          tilescale: 0,
          mapzoomin: 1,
          mapzoomout: 5,
          'image-format': 'jpg',
          worldtomap: [4, 0, 0, 0, 0, -4, 0, 1, 0],
          maptoworld: [0.25, 0, 0, 0, 0, 1, 0, -0.25, 0],
        },
      ],
    },
    {
      name: 'world_nether',
      title: 'world_nether',
      center: { x: 0, y: 89, z: 0 },
      maps: [
        {
          name: 'flat',
          title: 'Flat',
          prefix: 'flat',
          type: 'HDMapType',
          scale: 4,
          tilescale: 0,
          mapzoomin: 1,
          mapzoomout: 5,
          'image-format': 'jpg',
          worldtomap: [4, 0, 0, 0, 0, -4, 0, 1, 0],
          maptoworld: [0.25, 0, 0, 0, 0, 1, 0, -0.25, 0],
        },
      ],
    },
    {
      name: 'world_the_end',
      title: 'world_the_end',
      center: { x: 0, y: 89, z: 0 },
      maps: [
        {
          name: 'flat',
          title: 'Flat',
          prefix: 'flat',
          type: 'HDMapType',
          scale: 4,
          tilescale: 0,
          mapzoomin: 1,
          mapzoomout: 5,
          'image-format': 'jpg',
          worldtomap: [4, 0, 0, 0, 0, -4, 0, 1, 0],
          maptoworld: [0.25, 0, 0, 0, 0, 1, 0, -0.25, 0],
        },
      ],
    },
  ],
};
